'use client';

import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { usePathname } from '@/config';
import { Analytics } from '@/utils/analytics';

/** Matches bulk order ids (e.g. BO-1, BO-12345678910) */
const BULK_ORDER_ID_REGEX = /BO-\d+/;

const PageLoadEventProvider = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      const bulkOrderId = pathname.match(BULK_ORDER_ID_REGEX)?.[0];

      Analytics.trackEvent('page_view', {
        pathname,
        ...(bulkOrderId && { bulkOrderId }),
      });
    }
  }, [pathname]);

  return <>{children}</>;
};

export default PageLoadEventProvider;
